import React, { Component,useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import FilledInput from '@material-ui/core/FilledInput';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Grid from '@material-ui/core/Grid';
import liffHelper from '../../utils/liffHelper';
import { Redirect } from 'react-router-dom'
import Noredi from './ProfileNoredi'
import queryString from 'query-string';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
// import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
// import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
// import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: theme.spacing(3, 2)
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: 200,
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));



// export default function SearchAppBar() {
export default class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: false,
      password: '',
      weight: '',
      weightRange: '',
      showPassword: false,
    };
  }
  async componentDidMount() {
    var url = this.props.location.search;
    var params = queryString.parse(url);
    alert(params.id)
    if(params.id != undefined){
        this.setState({
          amount: params.id
        })
      }
    // alert(this.props.location.state.id)
    // const  profile = await liffHelper.getProfile()
    // this.setState({ profile });
    //   const  nna = await liffHelper.checkmongo(this.state.profile.userId)
    //   // alert(nna)
    //   if(nna != undefined){
    //   this.setState({
    //     mongo: {
    //       ...this.state.mongo,
    //       Ck_Name: nna.Ck_Name,
    //     }
    //   })
    //   }else{
    //     this.setState({
    //       redi: {
    //         ...this.state.redi,
    //         redirect: true,
    //       }
    //     })
    //   }
  }
  renderRedirect = () => {
    // if (this.state.password == "Admin") {
    //   return <Redirect
    //     to={{
    //       pathname: '/regisadmin',
    //       state: {password : this.state.password }
    //     }}
    //   />  
    // }
  }

  handleChange(event) {
    this.setState({ password: event.target.value });
  }

  render() {
    const classes = useStyles();
    // const classes = this.props;
    return (
      <div className={classes.root} >
        <Noredi />
        {this.renderRedirect()}
        <main  style={{ width: 'auto',
        marginLeft: "8%",
        marginRight: "8%",
      }} >
        <Paper className={classes.paper} style={{ marginTop: "1%", padding: "8%" }}>
          <CssBaseline />
          <div className={classes.paper}>
            {/* <Avatar className={classes.avatar}> */}
              {/* <LockOutlinedIcon style={{ justifyContent: 'center',
    alignItems: 'center',  }} /> */}
            {/* </Avatar> */}
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <form className={classes.form} noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                // label="Admin Messenger Rafco"
                label={this.state.amount}
                name="email"
                autoComplete="email"
                autoFocus
                disabled="disabled"
              />
              {/* {this.state.amount} */}
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                onChange={this.handleChange.bind(this)}
              />
            </form>
          </div>
        </Paper>
        </main>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// src/pages/components/questions.js